





















import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import { EStatementStatuses } from '@zunta/configurations'

@Component({
  props: {},
  components: {
    Modal
  }
})
export default class TaskFinishedModal extends Vue {
}
